module.exports = __webpack_public_path__ + "static/media/TUNE_4431.819fcd4b.jpg";